module.exports = __webpack_public_path__ + "img/logo-bb-mark.126f4ff0.svg";